// extracted by mini-css-extract-plugin
export default {"ssoSwitchWrapper":"SSOSwitch_ssoSwitchWrapper__ohPOf","switch":"SSOSwitch_switch__rkL6f"};